function validate_email(email) {
    let re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return re.test(email);
}

function show_hint(element) {
    element.addClass("red-border");
}

function hide_hint(element) {
    element.removeClass("red-border");
}

function unpress_button(element) {
    element.css("opacity", "1");
}

$(document).ready(function () {
    $(".get-an-offer").click(function (event) {
        event.preventDefault();
        let form_id = this.form.id,
            formValid = true,
            $email = $("#" + form_id + " input.email"),
            $name = $("#" + form_id + " input.name"),
            $send_button = $("#" + form_id + " button");

        hide_hint($email);
        hide_hint($name);

        if (!validate_email($email.val())) {
            show_hint($email);
            formValid = false;
        }
        if ($name.val() === '') {
            show_hint($name);
            formValid = false;
        }
        if (formValid) {
            $.ajax({
                type   : "POST",
                url    : "https://myaccount.keepgo.com/send_form",
                data   : $("form#" + form_id).serialize(),
                success: function () {
                    $('.success-' + form_id).fadeIn('fast');
                    $('.error').fadeOut('fast');
                    $("#" + form_id + " input.name").val('');
                    $("#" + form_id + " input.email").val('');
                    $("#" + form_id + " input.phone").val('');
                    $("#" + form_id + " textarea").val('');
                },
                error  : function (XMLHttpRequest, textStatus, errorThrown) {
                    $('.success-' + form_id).fadeOut('fast');
                    $('.error').fadeIn('fast');
                }
            });

            try {
                ga('send', 'event', {eventCategory: 'button', eventAction: 'click', eventLabel: 'getoffer', eventValue: 1});
            } catch (error) {
            }
        }

        unpress_button($send_button);

        return false;
    });
});